<template>
  <v-card class="pa-4 box_shadow_class fill-height mt-0">
    <div>
      <div>
        <span>
          <HeaderComponent :headerTitle="headerText" />
        </span>
      </div>

      <v-container class="ma-0 pa-0" fluid grid-list-lg>
        <!-- <v-layout class="ma-0 pa-0" row wrap> -->
          <!-- <v-flex class xs12 style="background-color: grey lighten-3"> -->
            <v-row>
              <v-col xs3 cols="3" sm="3" md="3" class="mb-10" v-if="!$isRelianceClient()">
                <router-link :to="{ name: 'StoreMasterUploadList'}">
                  <v-card class="box_shadow_class">
                    <div align="center" justify="center">
                      <img class="mt-3" src="@/assets/images/icons/inwardmodule.svg" width="64" height="64" />
                    </div>
                    <div class="mt-8 text-color heading-style" align="center" justify="center">
                      Inward Module
                    </div>
                  </v-card>
                </router-link>
              </v-col>

              <v-col xs3 cols="3" sm="3" md="3" class="mb-10" v-if="!$isRelianceClient()">
                <router-link :to="{ name: 'SkuMasterUploadList'}">
                  <v-card class="box_shadow_class">
                    <div align="center" justify="center">
                      <img class="mt-3" src="@/assets/images/icons/gradingmodule.svg" width="64" height="64" />
                    </div>
                    <div class="mt-8 text-color heading-style" align="center" justify="center">
                      Grading Module
                    </div>
                  </v-card>
                </router-link>
              </v-col>

              <v-col xs3 cols="3" sm="3" md="3" class="mb-10">
                <router-link :to="{ name: 'SubLocations' }">
                  <v-card class="box_shadow_class">
                    <div align="center" justify="center">
                      <img class="mt-3" src="@/assets/images/putaway_module.svg" width="64" height="64" />
                    </div>
                    <div class="mt-8 text-color heading-style" align="center" justify="center">
                      Putaway Module
                    </div>
                  </v-card>
                </router-link>
              </v-col>
              <v-col xs3 cols="3" sm="3" md="3" v-if="!$isRelianceClient()" class="mb-10">
                <router-link :to="{ name: 'Insurance'}">
                  <v-card class="box_shadow_class">
                    <div align="center" justify="center">
                      <img class="mt-3" src="@/assets/images/icons/insurance.svg" width="64" height="64" />
                    </div>
                    <div class="mt-8 text-color heading-style" align="center" justify="center">
                      Insurance
                    </div>
                  </v-card>
                </router-link>
              </v-col>
              <v-col xs3 cols="3" sm="3" md="3" class="mb-10">
                <router-link :to="{ name: 'ItemMaster'}">
                  <v-card class="box_shadow_class">
                    <div align="center" justify="center" @click="updateActiveTab">
                      <img class="mt-3" src="@/assets/images/icons/itemmaster.svg" width="64" height="64" />
                    </div>
                    <div class="mt-8 text-color heading-style" align="center" justify="center">
                      Item Master
                    </div>
                  </v-card>
                </router-link>
              </v-col>

              <v-col xs3 cols="3" sm="3" md="3" class="mb-10">
                <router-link :to="{ name: 'locationMaster'}">
                  <v-card class="box_shadow_class">
                    <div align="center" justify="center">
                      <img class="mt-3" src="@/assets/images/icons/locationmaster.svg" width="64" height="64" />
                    </div>
                    <div class="mt-8 text-color heading-style" align="center" justify="center">
                      Location Master
                    </div>
                  </v-card>
                </router-link>
              </v-col>

              <v-col xs3 cols="3" sm="3" md="3" class="mb-10">
                <router-link :to="{ name: 'userMaster' }">
                  <v-card class="box_shadow_class">
                    <div align="center" justify="center">
                      <img class="mt-3" src="@/assets/images/icons/usermaster.svg" width="64" height="64" />
                    </div>
                    <div class="mt-8 text-color heading-style" align="center" justify="center">
                      User Master
                    </div>
                  </v-card>
                </router-link>
              </v-col>

              <v-col xs3 cols="3" sm="3" md="3" class="mb-10">
                <router-link :to="{ name: 'vendorMater' }">
                  <v-card class="box_shadow_class">
                    <div align="center" justify="center">
                      <img class="mt-3" src="@/assets/images/icons/vendormaster.svg" width="64" height="64" />
                    </div>
                    <div class="mt-8 text-color heading-style" align="center" justify="center">
                      Vendor Master
                    </div>
                  </v-card>
                </router-link>
              </v-col>
              <v-col xs3 cols="3" sm="3" md="3" class="mb-10">
                <router-link :to="{ name: 'approvalMatrix' }">
                  <v-card class="box_shadow_class">
                    <div align="center" justify="center">
                      <img class="mt-3" src="@/assets/images/icons/approval-matrix.png" width="64" height="64" />
                    </div>
                    <div class="mt-8 text-color heading-style" align="center" justify="center">
                      Approval Matrix
                    </div>
                  </v-card>
                </router-link>
              </v-col>

              <!-- <v-col xs3 cols="4" sm="4" md="4">
                <router-link :to="{ name: 'SkuMasterUploadList'}">
                  <v-card
                    class="pa-4 box_shadow_class"
                  >
                    <div align="center" justify="center">
                      <img
                        class="mt-3"
                        src="@/assets/images/icons/parental-control.png"
                        width="108"
                        height="108"
                      />
                    </div>
                    <div class="mt-3 text-color" align="center" justify="center">
                      Module 5
                    </div>
                  </v-card>
                </router-link>
              </v-col>

              <v-col xs3 cols="4" sm="4" md="4">
                <router-link :to="{ name: 'VendorMasterUploadList', params: { type: 'Brand Call-Log' }}">
                  <v-card
                    class="pa-4 box_shadow_class"
                  >
                    <div align="center" justify="center">
                      <img
                        class="mt-3"
                        src="@/assets/images/icons/parental-control.png"
                        width="108"
                        height="108"
                      />
                    </div>
                    <div class="mt-3 text-color" align="center" justify="center">
                      Module 6
                    </div>
                  </v-card>
                </router-link>
              </v-col> -->
            </v-row>
          <!-- </v-flex> -->
        <!-- </v-layout> -->
      </v-container>

    </div>
  </v-card>
</template>

<style scoped>
  .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)
    > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes)
    .v-slide-group__prev {
    display: none;
    visibility: hidden;
  }

  .text-color {
    color: #002F9E;
  }

  .header-background {
    background-color: #0357d0;
  }

  .box_shadow_class {
    background: #ffffff;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25) !important;
    border-radius: 4px;
  }
  
  .fill-height {
  height: 100vh;
}
  .heading-style{
    padding: 18px 0px;
    background: #DFDFDF;
  }
   
</style> 

<script>
  import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
  import { mapState } from "vuex";

  export default {
    data() {
      return {
        headerText: "Configuration Settings",
        organization_name :'',
      };
    },

    components: {
      HeaderComponent,
    },
    created(){
      this.organization_name = this.$store.state.organization_name
      this.$store.commit("setActiveTab", {});
    },
    methods:{
      updateActiveTab(){
        this.$store.commit('setActiveTab',{
          'active_tab' : ''
        })
      }
    },

    computed: mapState(["currentUser", "signedIn"])
  };
</script>
